import getCombatantById from './getCombatantById'
import getCombatantSlots from './getCombatantSlots'
import getActionToSlot from './getActionToSlot'
import isContiguousAction from './isContiguousAction'

function resolveRoundSlotLimit(slots, round, combatantCA) {
  const roundActions = (Array.isArray(slots?.actions) ? slots.actions : []).filter(
    (action) => action?.round === round,
  )

  if (roundActions.length === 0) {
    return combatantCA
  }

  const actionCount = Number(roundActions[0]?.action_count)
  const actualActionCount = Number(roundActions[0]?.actual_action_count)

  if (!Number.isFinite(actionCount) || !Number.isFinite(actualActionCount)) {
    return combatantCA
  }

  return getActionToSlot(combatantCA, actualActionCount, actionCount)
}
//------------------------
// is contiguous counters
//------------------------
// prevent gaps when adding new counters where:
// a) counters exist
// b) no counters exist
//-----------------------------------------
export default async function isContiguousCounters(parm) {
  console.log('---------------------------')
  console.log('IN isContiguousCounters parm = ', parm)
  let consecutive = false
  //---------------
  // get combatant
  //---------------
  let c = getCombatantById(parm.id)

  return new Promise((resolve, reject) => {
    //-------------------------
    // get all combatant slots (re/actions/markers)
    //-------------------------
    console.log('0. isContiguousCounters - off to getCombatantSlots c.slug = ' + c.slug)
    let call = getCombatantSlots(c.slug)
    call
      .then((slots) => {
        console.log('1. isContiguousCounters - back from getCombatantSlots slots = ', slots)
        //---------------------------
        // get markers for combatant
        //---------------------------
        let markers = slots.markers.filter((m) => {
          console.log(
            '2. isContiguousCounters parm.ca = ' +
              parm.ca +
              ' / parm.arena_round = ' +
              parm.arena_round +
              ' / m.marker_count = ' +
              m.marker_count +
              ' / m.round = ' +
              m.round +
              ' / m.number = ' +
              m.number,
          )
          return (
            m.round >= parm.arena_round && // return only markers >= current round (ignore previous rounds)
            m.marker_count < parm.ca // where number of markers < available CAs
          )
        })
        console.log('3. isContiguousCounters qualifying markers = ', markers)
        //========================================================================================================
        // A. where markers exist - get round of last marker
        //---------------------------------------------------
        if (markers.length > 0) {
          let last_marker = markers[markers.length - 1]
          console.log('4. isContiguousCounters - last marker = ', last_marker)
          console.log('5. isContiguousCounters - round of last marker = ' + last_marker.round)
          console.log(
            '6. isContiguousCounters - checking if last marker round < view round where marker is being added',
          )
          console.log('7. isContiguousCounters - last_marker.round = ' + last_marker.round)
          console.log('8. isContiguousCounters - parm.view_round = ' + parm.view_round)
          //----------------------------------------------
          // A1. if last round < view round = consecutive
          //----------------------------------------------
          if (last_marker.round < parm.view_round) {
            console.log('9. isContiguousCounters - last_marker.round < parm.view_round = TRUE')
            console.log('9a. isContiguousCounters - last_marker.number = ' + last_marker.number)
            console.log('9b. isContiguousCounters - parm.ca = ' + parm.ca)
            const roundSlotLimit = resolveRoundSlotLimit(slots, last_marker.round, parm.ca)
            console.log('9ba. isContiguousCounters - roundSlotLimit = ' + roundSlotLimit)
            //------------------------------------------------------------------------------
            // A1.1 check last marker number in prev round = their CA - if not = gap in counters
            //------------------------------------------------------------------------------
            if (last_marker.number !== roundSlotLimit) {
              console.log(
                '9c. isContiguousCounters - the last marker is NOT last action in previous round',
              )
              consecutive = false
              //------------------------------------------
              // A1.2 else last marker in prev round = counter
              //------------------------------------------
            } else {
              console.log(
                '9d. isContiguousCounters - the last marker IS last action in previous round',
              )
              consecutive = true
            }
            //---------------------------------------------------------------------------------------
            // A2. else got markers in same round = consecutive (counters bumped to left so no gaps)
            //---------------------------------------------------------------------------------------
          } else {
            console.log('10. isContiguousCounters - same round - consecutive = TRUE')
            consecutive = true
          }
          //========================================================================================================
          // B. no markers + view round > cur round - consecutive
          // (e.g. could be adding marker in view round BUT nothing in prev round - incorrect but need to trap)
          //-------------------------------------------------------------------
        } else if (slots.markers.length == 0 && parm.view_round > parm.arena_round) {
          console.log(
            '11. isContiguousCounters - no existing counters; reusing action contiguity check',
          )

          return isContiguousAction({
            payload: {
              combatant_slug: c.slug,
              round: parm.view_round - 1,
            },
            combatant_ca: parm.ca,
          })
            .then((response) => {
              console.log('11a. isContiguousCounters - action contiguity response = ', response)
              resolve(response.contiguous)
            })
            .catch((err) => {
              reject(err)
            })
          //========================================================================================================
          // C. no markers same round - consecutive (markers bumped to left so no gaps)
          //----------------------------------------------------------------------------
        } else {
          console.log('12. isContiguousCounters - else default - consecutive = TRUE')
          consecutive = true
        }
        //-------------
        // return flag
        //-------------
        resolve(consecutive)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
